import { useState } from 'react';
import { Clock, Edit2, Trash2 } from 'lucide-react';
import { platformLogos } from '../../../constants/platformLogos';



const ScheduledPostCard = ({ post, onEdit, onDelete }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getPlatformLogo = (platformName) => {
    const platformKey = platformName?.toLowerCase();
    return platformLogos?.[platformKey] || null;
  };

  const formatDate = (date) => {
    if (!date) return '';
    const postDate = new Date(date);
    const now = new Date();
    const diffTime = postDate - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Tomorrow';
    if (diffDays > 1 && diffDays <= 7) return `In ${diffDays} days`;
    return postDate?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const formatTime = (date) => {
    if (!date) return '';
    return new Date(date)?.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  };

  return (
    <div className="border border-border rounded-lg p-4 hover:bg-accent/5 transition-colors">
      <div className="flex items-start gap-3">
        {post?.media && (
          <img
            src={post?.media}
            alt={post?.mediaAlt || 'Post thumbnail'}
            className="w-12 h-12 rounded object-cover flex-shrink-0"
          />
        )}
        <div className="flex-1 min-w-0">
          <p className="text-sm text-foreground line-clamp-2 mb-2">{post?.content}</p>
          <div className="flex items-center gap-2 flex-wrap mb-2">
            {post?.platforms?.map((platform, idx) => {
              const platformConfig = getPlatformLogo(platform);
              return platformConfig ? (
                <img
                  key={idx}
                  src={platformConfig?.logo}
                  alt={platformConfig?.alt}
                  className="w-4 h-4 object-contain"
                />
              ) : (
                <span key={idx} className="text-xs text-muted-foreground">{platform}</span>
              );
            })}
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Clock className="w-3 h-3" />
              <span>{formatDate(post?.scheduledDate)} at {formatTime(post?.scheduledDate)}</span>
            </div>
            <div className="flex items-center gap-1">
              <button
                onClick={() => onEdit(post?.id)}
                className="p-1 hover:bg-accent/10 rounded"
                aria-label="Edit post"
              >
                <Edit2 className="w-4 h-4 text-muted-foreground" />
              </button>
              <button
                onClick={() => onDelete(post?.id)}
                className="p-1 hover:bg-destructive/10 rounded"
                aria-label="Delete post"
              >
                <Trash2 className="w-4 h-4 text-destructive" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduledPostCard;